import useServiceFactory from "../serviceFactory";


const apiUrl = `/administracion/IncidenciasCobros`;

const useApiIncidenciasCobros = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        filtrar: async (params) => service.get(`${apiUrl}`, { params, showLoading: true }),
        obtener: async (id) => service.get(`${apiUrl}/${id}`, { showLoading: true }),
        actualizar: async (id, params) => service.put(`${apiUrl}/${id}`, params),
    }
};

export default useApiIncidenciasCobros;
